import type { UpdateableAreaSubstrate } from '../../..'

/**
 * Convert updateable hours to areaSubstrate hours
 */
export default function toSaveableHours(areaSubstrate: UpdateableAreaSubstrate): {
  override_hours: boolean
  hours: number
  override_hours_value: number
} {
  return {
    override_hours: areaSubstrate.hours?.useCustom ?? false,
    override_hours_value: areaSubstrate.hours?.custom ?? 0,
    hours: areaSubstrate.hours?.default ?? 0
  }
}
